import { graphql, useStaticQuery } from "gatsby"

import { CompanyStatisticQueryResult } from "./types"
import { validateCompanyStatistics } from "./utils"

export function useCompanyStatsQuery() {
  const queryResults = useStaticQuery<CompanyStatisticQueryResult>(graphql`
    query CompanyStatistics {
      datoCms {
        allCompanyStatisticValues(first: 500) {
          title
          baseValue
          unit
        }
      }
    }
  `)
  validateCompanyStatistics(queryResults)
  return queryResults
}
